import { render, staticRenderFns } from "./RecieptAdjustment.vue?vue&type=template&id=ad6494de"
import script from "./RecieptAdjustment.vue?vue&type=script&lang=js"
export * from "./RecieptAdjustment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports